<template>
  <div class="third">
    <div style="margin-bottom: 10px">
      <!-- <ZTB /> -->
    </div>
    <div style="position: relative">
      <img
        src="@/assets/img/caodi3.png"
        style="width: 100%; height: 155px"
        alt=""
      />
    </div>

    <!-- 项目查询 -->
    <div style="margin-bottom: 10px">
      <JJXM></JJXM>
    </div>
    <YXIMG></YXIMG>
    <PYSYXZCSR v-if="cityDetail.cityName == '濮阳市'" />
    <div
      class="jrfw"
      v-if="
        cityDetail.cityName != '濮阳市华龙区' &&
        cityDetail.cityName != '濮阳市清丰县' &&
        !cityDetail.notHaveJRFW
      "
      @click="goJRFWInfo"
      :style="{ cursor: cityDetail.goJRFWInfo ? 'pointer' : 'auto' }"
    >
      <div>
        <span>金融服务</span>
        <span>一站式金融服务平台</span>
      </div>
    </div>
    <YQLJ
      v-if="
        cityDetail.cityName == '濮阳市华龙区' ||
        cityDetail.cityName == '濮阳市清丰县'
      "
    />
    <div>
      <!-- <YX v-if="cityDetail.cityName != '华龙区'"></YX> -->
    </div>
    <!-- <JRFW /> -->
    <!-- <div style="margin-top:20px;position: relative;">
      <img src="@/assets/img/pingyuan.png" style="width:100%" alt="">
      <span class="imageSpan">唤醒农村沉睡的资产
        | 增加农村财产性收入 |
        加快新农村建设步伐</span>
    </div> -->
    <!-- <RZGG></RZGG> -->
  </div>
</template>

<script>
import JJXM from './Third/竞价项目.vue'
import ZTB from './Third/招投标.vue'
import TDXX from './Third/土地信息.vue'
import TDZCJYTDZSXX from './Third/政策交易土地招商.vue'
import JRFW from './Third/金融服务.vue'
import XMCX from './Third/项目查询.vue'
import YXZC from './Third/意向转出.vue'
import YXSR from './Third/意向受让.vue'
import RZCX from './Third/融资查询.vue'
import ZLXZ from './Third/资料下载.vue'
import GGL from './Third/公告栏.vue'
import YXIMG from './Third/意向转出受让鉴证书图片.vue'
import YX from './Third/意向转出受让.vue'
import PYSYXZCSR from './Third/意向转出受让_濮阳市.vue'
import GSGG from './First/公示公告.vue'
import YQLJ from './Third/友情链接2.vue'
import { cityDetail } from '../../util/mainOption'

export default {
  data () {
    return {}
  },
  components: {
    JJXM,
    TDXX,
    TDZCJYTDZSXX,
    JRFW,
    XMCX,
    YXZC,
    YXSR,
    RZCX,
    ZLXZ,
    GGL,
    YXIMG,
    YX,
    GSGG,
    ZTB,
    YQLJ,
    PYSYXZCSR,
  },
  created () { },
  mounted () { },
  computed: {},
  watch: {},
  methods: {
    goJRFWInfo () {
      if (cityDetail.goJRFWInfo && cityDetail.cityName == "信阳市") {
        this.$router.push({
          path: '/jrfwListXXS',
        })
      } else if (cityDetail.goJRFWInfo && cityDetail.cityName == "获嘉县") {
        this.$router.push({
          path: '/jrfwListHJX',
        })
      }
    }
  },
}
</script>

<style scoped>
.imageSpan {
  font-size: 28px;
  position: absolute;
  white-space: nowrap;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  color: white;
  font-weight: 550;
}
.jrfw {
  background: url("../../assets/img/jrfw.png") no-repeat;
  background-size: 100% 100%;
  height: 300px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.jrfw > div {
  display: flex;
  align-items: center;
}
.jrfw > div > span:first-child {
  font-size: 70px;
  color: #fff;
  font-weight: bold;
  letter-spacing: 10px;
  text-shadow: 0px 7px 5px rgba(133, 133, 133, 1),
    0px 8px 5px rgba(133, 133, 133, 1), 0px 13px 6px rgba(0, 0, 0, 0.3),
    0px 14px 6px rgba(0, 0, 0, 0.3), 0px 15px 6px rgba(0, 0, 0, 0.3);
}
.jrfw > div > span:last-child {
  font-size: 70px;
  color: #fff;
  letter-spacing: 4px;
}
</style>
